<dashboardnav>
  <cradua-obligationperiod
  [obligationperiods]="obligationperiods$ | async"
  (obligationperiod)="onSubmitObligationPeriod($event)"
  (deleteObligationPeriodEvent)="onDeleteObligationPeriod($event)"
  *ngIf="(isLoadingObligationPeriod$ | async ) === false"
  >
</cradua-obligationperiod>

  <mrsoftapps-epims-reference-spinner
  *ngIf="(isLoadingObligationPeriod$ | async) === true"
>
  </mrsoftapps-epims-reference-spinner>
  <!-- <pre>{{isLoading$ | async | json}}</pre> -->
</dashboardnav>
